import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Input, Form, TextArea, Button, Grid, Radio } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';

class GenerateReceipt extends React.Component {

  state = {
    maxWidth: 'sm', value: 2, fullWidth: true, towards: '', refno: '', date: this.getFormatedDate(new Date(), 'toDate')
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  saveAndGenerateInvoice() {
    let context = this;
    $.ajax({
      type: 'POST',
      data: { id: context.props.id, date: context.state.date, refno: context.state.refno, towards: context.state.towards },
      url: Server() + 'receipt/insertreceiptData.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ openReceiptDialog: false })
          let open = Server() + "pdf/receipt/receiptpdf.php?voucher="+context.props.receiptVoucher+"&copy="+context.state.value;
          window.open(open);
        }
        else {
          context.setState({ openReceiptDialog: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  handleChange1 = name => event => {
    this.setState({ [name]: event.target.value })
  }

  getData() {
    let context = this;
    $.ajax({
      type: 'POST',
      data: { id: context.props.id },
      url: Server() + 'receipt/getreceiptData.php',
      success: function(data) {
        let date = context.state.state;
        let towards = context.state.towards;
        let refno = context.state.refno;
        try {
          data = JSON.parse(data);
          data.map((c) => {
            date = c.date; towards = c.towards; refno = c.ref_no;
          })
        } catch (error) {
        }
        context.setState({ 
          openReceiptDialog: true, date, towards, refno,
          voucher_no: context.props.receiptVoucher
      })
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
    
  }

  handleChange = (e, { value }) => this.setState({ value })

  render() {
    return (
      <div>
        <u style={{color: 'blue', cursor: 'pointer'}} onClick={this.getData.bind(this)}>
            {this.props.receiptVoucher}
        </u>
        <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.openReceiptDialog}
            onClose={ () => { this.setState({ openReceiptDialog: false }) }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Generate Receipt</DialogTitle>
            <DialogContent>
                <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      Date<br/>
                      <input type="date" value={this.state.date} style={{width: '100%', height: 35 }}
                        onChange={ (event) => { this.setState({ date: event.target.value }) }} />
                      </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                        Ref No<br/>
                        <Input fluid value={this.state.refno} onChange={this.handleChange1('refno')} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                        Towards<br/>
                        <Form>
                            <TextArea value={this.state.towards} onChange={this.handleChange1('towards')} fluid />
                        </Form>
                    </Grid.Column> 
                </Grid>

            </DialogContent>
            <DialogActions>

              <div style={{display: 'flex'}}>
                <Form.Field>
                  <Radio label='Print Only Original Copy' name='radioGroup' value={1}
                    checked={this.state.value === 1} onChange={this.handleChange} />
                </Form.Field>
                <Form.Field style={{marginLeft: '20px', marginRight: '20px'}}>
                  <Radio label='Print With Duplicate Copy' name='radioGroup' value={2}
                    checked={this.state.value === 2} onChange={this.handleChange} />
                </Form.Field>
              </div>

              <Button color='primary' variant='outlined' onClick={ () => { this.setState({ openReceiptDialog: false }) }}>Close</Button>
              <Button color='primary' variant='outlined' onClick={this.saveAndGenerateInvoice.bind(this)}>Submit</Button>
            </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default GenerateReceipt;